import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que leer mucho?',
  a: 'No. El manual tiene menos de 40 páginas. Está diseñado para leerlo en una hora y aplicarlo ese mismo fin de semana.'
}, {
  q: '¿Necesito comprar suplementos caros?',
  a: 'No. Todo lo que necesitás ya lo tenés en tu casa. El protocolo no depende de ningún producto externo.'
}, {
  q: '¿Qué pasa si mi trabajo es muy estresante?',
  a: 'Justamente para eso está hecho. No cambia tu trabajo. Cambia cómo tu sistema nervioso procesa el estrés de ese trabajo.'
}, {
  q: '¿Funciona si tengo ansiedad clínica?',
  a: 'El Reset es un protocolo de gestión del estrés cotidiano, no un tratamiento médico. Si tenés diagnóstico clínico, consultá con tu profesional de salud antes de aplicarlo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-6 bg-charcoal-900" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <FadeIn data-id="element-13">
          <h2 className="font-heading text-4xl sm:text-5xl text-offwhite mb-12 text-center" data-id="element-14">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={0.1 * index} data-id="element-16">
                <div className="border border-charcoal-700 rounded-sm bg-charcoal-800/50 overflow-hidden" data-id="element-17">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-charcoal-800 transition-colors" data-id="element-18">
                    <span className="text-lg font-medium text-offwhite pr-4" data-id="element-19">
                      {faq.q}
                    </span>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-20">
                      <ChevronDownIcon className="w-5 h-5 text-amber shrink-0" data-id="element-21" />
                    </motion.div>
                  </button>
                  <AnimatePresence data-id="element-22">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-23">
                        <div className="p-6 pt-0 text-offwhite/70 font-light leading-relaxed border-t border-charcoal-700/50 mt-2" data-id="element-24">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}